import CompareStore from './comporeStore';

const compareStore = new CompareStore();

export default compareStore;
